import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  paper: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    overflow: 'visible',
  },
});
